import { HeroContentLeft } from "./HeroContentLeft";
import HomePageContent from "./HomePageContent";
import HomePageHoverContent from "./HomePageHoverContent";
import FeaturesSection from "./FeaturesSection";
import FeaturedProductSlider from "./FeaturedProductSlider";
import { PageMeta, BreadcrumbJsonLd } from "./seo";

function HomePage() {
  return (
    <main>
      <PageMeta
        title="首頁"
        description="馬來西亞頂級貓山王榴槤批發零售｜鮮果、急凍產品｜香港直送｜每週新鮮空運到港。"
        canonicalPath="/"
      />
      <BreadcrumbJsonLd items={[{ name: "首頁", path: "/" }]} />
      <HeroContentLeft />
      <FeaturesSection />
      <FeaturedProductSlider />
      <HomePageContent />
      <HomePageHoverContent />
    </main>
  );
}

export default HomePage;
